import { z } from 'zod';
import type { BackgroundTask, AxonEvent } from '@reflex/shared';
import { parseEventPayload } from '@reflex/ui/client/event-utils';
import type { AgentActivityBackgroundTask } from '@reflex/ui/components/agent/AgentActivityBar';

const CommandSchema = z.object({
  params: z.object({
    item: z.object({
      type: z.literal('commandExecution'),
      id: z.string(),
      command: z.string(),
    }),
  }),
});

/** The agent snapshot owns membership; paged tool items only enrich labels. */
export function deriveBackgroundTasks(
  events: AxonEvent[],
  active: readonly BackgroundTask[],
): AgentActivityBackgroundTask[] {
  const commands = new Map<string, string>();
  for (const event of events) {
    const eventType: string = event.type;
    if (eventType === 'item/started' || eventType === 'item/completed') {
      const parsed = CommandSchema.safeParse(parseEventPayload(event.payload));
      if (parsed.success) commands.set(parsed.data.params.item.id, parsed.data.params.item.command);
    }
  }
  return active.map((task) => ({
    ...task,
    label:
      commands.get(task.id) ??
      (task.kind === 'command'
        ? 'Background command'
        : task.kind === 'agent'
          ? 'Background agent'
          : 'Background task'),
  }));
}
